module.exports = __webpack_public_path__ + "img/bdo.ef6b7840.png";